export enum LegalActionsTypes {
  SET_DOCUMENTS = 'SET_DOCUMENTS',
}
